export default {
    OPENAI_API_KEY: "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",
    API_ENDPOINT: 'https://ray9jeckge.execute-api.us-west-2.amazonaws.com/dev',
    API_KEY: '3INqoKYrXh1QSeUK9nE4e2iTmtUH8byt50Zzhe97'
};
